import { render } from "./v-faq.vue?vue&type=template&id=5efad303&scoped=true"
import script from "./v-faq.vue?vue&type=script&lang=js"
export * from "./v-faq.vue?vue&type=script&lang=js"

import "./v-faq.vue?vue&type=style&index=0&id=5efad303&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5efad303"

export default script